import React , { useEffect, useState, useRef } from 'react'
import { json, useNavigate, useLocation } from "react-router-dom";
import SuccessPostLogin from "./SuccessPostLogin";
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import { useDispatch, useSelector } from "react-redux";
import { addProductsToCart } from "../../store/actions/ProductsActions";
import { getTotal } from './selectProducts';
import ApiService from '../../services/api.service';
import { getCurrentDate, getMaskedPhone, currencyFormatter } from '../common/Utils'
import Loader from '../common/Loader'
import BreadCrumbs from '../common/BreadCrumbs';
import { emptyCart } from "../../store/actions/ProductsActions";
import { toTitleCase } from './summary';
function SchoolFeeSummary() {
    const [modalVisible, setModalVisible] = useState(false);
    const [famersOtp, setFarmersOtp] = useState("")
    const [otpState, setOtpState] = useState("r")
    const [otpResend, setOtpResend] = useState(true)
    const [farmerId, setFarmerId] = useState('')
    const [error, setError] = useState('');
    const [modalprops, setModalProps] = useState({})
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const farmerInfo = useSelector((state) => state.farmer)
    const merchantInfo = useSelector((state) => state.userCredentials)
    const [loader, showLoader] = useState(false);
    const [balance_err, setBalanceErr] = useState();
    const[steps, setSteps] = useState([{ 'title': 'Products', 'name':'products', 'path': '/select-products', 'current': false }, { 'title': 'Summary', 'name':'summary', 'path': '/summary', 'current': true }])
    const [otp1, setOtp1] = useState('')
    const [otp2, setOtp2] = useState('')
    const [otp3, setOtp3] = useState('')
    const [otp4, setOtp4] = useState('')
    const ref_input1 = useRef();
    const ref_input2 = useRef();
    const ref_input3 = useRef()
    const ref_input4 = useRef();
    const transotp = otp1 + otp2 + otp3 + otp4;
    const OTP_DELAY = 120;
    const walletinfo = useSelector((state) => { try{return JSON.parse(state.wallet_info);} catch(e){return {}}  });
    const cartProduct =  useSelector((state) => {
        return state.cart;
    });

    const selectedProduct = cartProduct[`${farmerInfo.idNumber}_${walletinfo.walletReferenceCode}`] !== undefined ? cartProduct[`${farmerInfo.idNumber}_${walletinfo.walletReferenceCode}`] : []

    const goToHome = ()=>{
        navigate("/")
        setModalVisible(false)
    }


    const requestParentOtp = () => {
        setSeconds(OTP_DELAY)
        showLoader(true)
        setOtpResend(true)
        const payload = {
            nationalId: farmerInfo.idNumber,
            products: [{
                "amount": currencyFormatter(cartProduct.feeAmount),
                "admissionNumber": cartProduct.admissionNumber,
                "studentsName": cartProduct.studentName,
                "schoolName": cartProduct.schoolName
            }]
        }


        if (parseInt(walletinfo.AvailableAmount) < parseInt(cartProduct.feeAmount)) {
            showLoader(false)
            setBalanceErr("An Error Occured:: Insufficient Wallet Balance")
            return
        }
        ApiService.post("/farmer/send_school_otp", payload).subscribe((res) => {
            if (res.status === 200) {
                setOtpState('v')
                showLoader(false)
            }
            showLoader(false)
        })
    }

    const validateFarmerOtp = (e) => {
        const payload = {
            username: farmerInfo.idNumber,
            otp: transotp,
        }
        ApiService.post("/auth/validate_otp", payload).subscribe((res) => {
            if (res.status === 200) {
                if (res.data.valid) {
                    setOtpResend(false)
                    setOtpState('s')
                    postTransaction();
                } else {
                    setError("Invalid OTP")
                }

            }

        })

    }


    const postTransaction = () => {
        showLoader(true)
        const payload = {
            admissionNumber:cartProduct.admissionNumber,
            studentName:cartProduct.studentName,
            paymentDescription:cartProduct.paymentDescription,
            merchantCode: cartProduct.schoolCode,
            nationalId: farmerInfo.idNumber,
            walletAccountNumber: walletinfo.PAN,
            walletReferenceCode: walletinfo.walletReferenceCode,
            transactionalAmount: cartProduct.feeAmount,
            isSchool: true,
            products: [{}],
        }
        console.log("------------------>>>" +JSON.stringify(payload))
        try {
            ApiService.post("/farmer/post_order_school", payload).subscribe((res) => {
                if (res.status === 200) {
                    if (res.data.processed) {
                        showLoader(false)
                        let modalprops = { modaltype: "Transaction Successful", reference_num: res.data.rtps_ref, balance: res.data.balance, date: getCurrentDate(), farmer_identity: toTitleCase(farmerInfo.firstName)+' '+toTitleCase(farmerInfo.middleName)+' - '+farmerInfo.idNumber, amount: currencyFormatter(cartProduct.feeAmount)+" KES", action: goToHome, phone: getMaskedPhone(farmerInfo.phoneNumber) }
                        setOtpState('s')
                        setModalProps(modalprops);
                        dispatch(emptyCart())
                        setModalVisible(true)
                        return
                    }
                    setError(res.data.message ? res.data.message : "Transaction Failed")
                    showLoader(false)
                    return
                } else if (res.status === 400) {
                    setError("Internal server error")
                    showLoader(false)
                    return
                }
                setError(res.data && res.data.message !== "" ? res.data.message : "Could not post transaction")
                showLoader(false)

            })
        } catch (e) {
            setError(e.message)
            showLoader(false)
        }
    }

    useEffect(() => {
        //call the function once on opening the component
        if (location.state !== undefined && location.state !== null) {
            setFarmerId(location.state.farmerID)
        }
    }, [])

    const [seconds, setSeconds] = useState(OTP_DELAY)
    useEffect(() => {
        if (seconds >= 1) {
            const interval = setInterval(() => {
                setSeconds((t) => t - 1)
            }, 1000)
            return () => clearInterval(interval);
        } else if (otpResend === true) {
            setOtpResend(false)
            setOtpState('r')
            return () => clearInterval(0);
        } else {
            setOtpResend(false)
            return () => clearInterval(0);
        }

    }, [seconds, otpResend])

    //send farmer Otp on first load
    useOnceCall(() => {
        requestParentOtp();
    })


    return (
        <div className="home_landing">
            {modalVisible && <SuccessPostLogin data={modalprops}/>}
            <Header />
            <div className="home_app">
                <LeftBar />
                <div className="home_data_template_preset">
                    <Loader loader={loader} />
                    <div className="summary">
                        <BreadCrumbs steps={steps}></BreadCrumbs>
                        <div className="summary_wrapper">
                            <h3 className="summary_wrapper_heading">
                                Summary
                            </h3>
                            <h6 className="summary_wrapper_heading" style={{ fontSize: 'small', fontStyle:'normal' }} >
                                <span>{walletinfo.wallet_name ? toTitleCase(walletinfo.wallet_name) : " "} Wallet </span>
                                <span style={{ fontWeight: 'normal' }}>Balance </span>
                                Kes {walletinfo.AvailableAmount ? currencyFormatter(walletinfo.AvailableAmount) : '0.00'}
                                <br></br><span className='error_label'> {balance_err ? balance_err : " "}  </span>
                            </h6>
                            <div className="summary_wrapper_selected_products_container">
                                <h4 className="summary_wrapper_selected_products_container_heading">
                                    Selected Products
                                </h4>
                                <div className="summary_wrapper_selected_products_container_mapper">
                                    <table className="summary_wrapper_table">
                                        <tbody>

                                        <tr className="summary_wrapper_table_tr">
                                            <th className="summary_wrapper_table_th mb-bold-text">Category</th>
                                            <th className="summary_wrapper_table_th mb-bold-text">Details</th>
                                        </tr>

                                        <tr className="summary_wrapper_table_tr">
                                            <td className="summary_wrapper_table_td mobile-word-wrap">School Name</td>
                                            <td className="summary_wrapper_table_td mobile-word-wrap">{cartProduct.schoolName}</td>
                                        </tr>
                                        <tr className="summary_wrapper_table_tr">
                                            <td className="summary_wrapper_table_td mobile-word-wrap">Student admin number</td>
                                            <td className="summary_wrapper_table_td mobile-word-wrap">{cartProduct.admissionNumber}</td>
                                        </tr>
                                        <tr className="summary_wrapper_table_tr">
                                            <td className="summary_wrapper_table_td mobile-word-wrap">Student name</td>
                                            <td className="summary_wrapper_table_td mobile-word-wrap">{cartProduct.studentName}</td>
                                        </tr>
                                        <tr className="summary_wrapper_table_tr">
                                            <td className="summary_wrapper_table_td mobile-word-wrap">School fees amount</td>
                                            <td className="summary_wrapper_table_td mobile-word-wrap">{currencyFormatter(Number(cartProduct.feeAmount))}</td>
                                        </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <form className="verify_wrapper_form">
                                    <div className="verify_wrapper_form_container flex-box">
                                        <label htmlFor="farmer_id" className="verify_wrapper_form_label">
                                            Enter the <b>verification code</b> sent to farmer at <strong>{getMaskedPhone(farmerInfo.phoneNumber)} </strong>via SMS
                                        </label>
                                        <div className="verify_wrapper_form_container_sub otp-box">
                                            <form className="otp-form">
                                                <input className="otp" type="text" ref={ref_input1} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp1(values.target.value); setError(''); }} onKeyUp={(e) => {
                                                    if (ref_input1.current.value != '') {
                                                        ref_input2.current.focus()
                                                    }
                                                }} maxlength='1' />
                                                <input className="otp" type="text" ref={ref_input2} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp2(values.target.value); setError(''); }} onKeyUp={(e) => {
                                                    if (ref_input2.current.value !== '' && e.key !== "Backspace") {
                                                        ref_input3.current.focus()
                                                    } else if (e.key === "Backspace") {
                                                        ref_input1.current.focus()
                                                    }
                                                }} maxlength='1' />
                                                <input className="otp" type="text" ref={ref_input3} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp3(values.target.value); setError(''); }} onKeyUp={(e) => {
                                                    if (ref_input3.current.value !== '' && e.key !== "Backspace") {
                                                        ref_input4.current.focus()
                                                    } else if (e.key === "Backspace") {
                                                        ref_input2.current.focus()
                                                    }
                                                }} maxlength='1' />
                                                <input className="otp" type="text" ref={ref_input4} onInput={(e) => { digitValidate(e) }} onChange={(values) => { setOtp4(values.target.value); setError(''); }} onKeyUp={(e) => {
                                                    if (ref_input4.current.value !== '' && e.key !== "Backspace") {
                                                        console.log(transotp)
                                                    } else if (e.key === "Backspace") {
                                                        ref_input3.current.focus()
                                                    }
                                                }} maxlength='1' />
                                            </form>
                                        </div>

                                        {error !== "" ? <> <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id"> {error}  </label> </> : <></>}
                                        {otpResend ? <label htmlFor="farmer_id" className="verify_wrapper_form_label invalid_id">  Didn't receive code? Resend in <b className={`counter _${seconds}`} >{Math.floor(seconds / (60))} min {Math.floor((seconds % (60)))}sec </b>  </label>
                                            : <label htmlFor="farmer_id" className="verify_wrapper_form_label invalid_id">  Didn't receive code? <strong onClick={(e) => { requestParentOtp(); }} style={{ cursor: 'pointer', color: '#018603' }}>Resend OTP</strong> </label>}
                                    </div>

                                </form>

                            </div>

                            <div className="summary_wrapper_btns">
                                <button onClick={()=> navigate("/school-fees")} className="verify_wrapper_form_btn_verify select back">
                                    Back
                                </button>
                                <button disabled={transotp.length === 4 ? '' : 'disabled'} onClick={(e) => { e.preventDefault(); validateFarmerOtp() }} className={`verify_wrapper_form_btn_verify select next ${transotp.length===4 ? '' : 'disabled'}`}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}

export const totalTransaction = (values) => {
    let total = 0
    for (let i = 0; i < values.length; i++) {
        total += (Number(values[i].price) * Number(values[i].quantity))
    }
    return total
}

export const digitValidate = function (ele) {
    ele.target.value = ele.target.value.replace(/[^0-9]/g, '');
}

function useOnceCall(cb, condition = true) {
    const isCalledRef = React.useRef(false);
    React.useEffect(() => {
        if (condition && !isCalledRef.current) {
            isCalledRef.current = true;
            cb();
        }
    }, [cb, condition]);
}

export default SchoolFeeSummary;